export default {
  slug: "/eyebrow-transplant",
  group: { href: "/hair", label: { en: "Hair restoration", ar: "زراعة الشعر" } },
  heroImage: "/assets/images/ai/services/hair/brows-approved.webp",

  en: {
    title: "Eyebrow Transplant in Istanbul",
    eyebrow: "Hair restoration",
    lead:
      "Single hairs are taken from the scalp and placed into the eyebrow at the angle each hair grows, " +
      "to rebuild a brow that over-plucking, scarring or genetics left thin.",
    cta: "Book a free assessment",
    heroAlt: "Eyebrow transplant consultation at Platinya Clinic",
    stats: [
      { value: "3–4 h", label: "Procedure time" },
      { value: "200–400", label: "Grafts per brow" },
      { value: "6–9 months", label: "Final shape" },
    ],
    candidate: {
      heading: "Who it is for",
      intro:
        "The brows are the most visible transplant on the face, so the first job is deciding whether the " +
        "shape is still there to be rebuilt.",
      items: [
        "Thinning from years of over-plucking where the follicles have stopped recovering",
        "Scarring from burns, cuts or permanent makeup removal",
        "Naturally sparse or asymmetrical brows, or loss after chemotherapy that has not recovered",
        "Healthy skin without active eczema, psoriasis or infection in the brow area",
      ],
      note:
        "If the brow is thin because of thyroid disease or a nutritional deficiency, that is treated first. " +
        "Hair taken from the scalp keeps growing like scalp hair, so it needs trimming — that is permanent " +
        "maintenance and should be understood before booking.",
    },
    techniques: {
      heading: "How it is done",
      intro: "Precision rather than volume: a few hundred single hairs, each placed at its own angle.",
      items: [
        {
          name: "Single-hair grafts",
          text:
            "Only one- and two-hair follicular units are used. Multi-hair grafts look clumped in a brow, " +
            "so the donor site is selected for fine, single hairs — often from behind the ear.",
        },
        {
          name: "Angle and direction",
          text:
            "Brow hairs grow upward and outward at the head of the brow and flatten towards the tail. " +
            "Each graft is placed individually to follow that pattern, otherwise the result reads as unnatural.",
        },
        {
          name: "Density in two passes",
          text:
            "A conservative first pass protects the blood supply of thin brow skin; a second session after " +
            "9–12 months adds density where it is needed rather than over-packing at the start.",
        },
      ],
    },
    journey: {
      heading: "From design to the final shape",
      steps: [
        {
          name: "Design on the face",
          text:
            "The brow is drawn with you sitting up, measured against the other side and the facial proportions, " +
            "and agreed before any graft is taken.",
        },
        {
          name: "Surgery",
          text:
            "Local anaesthesia. Extraction from the donor area, then implantation with fine needles. " +
            "Three to four hours for both brows.",
        },
        {
          name: "First ten days",
          text: "Small scabs; no makeup on the area, no rubbing, no sleeping face-down. Swelling settles in a week.",
        },
        {
          name: "Weeks 3–8",
          text: "Most grafts shed, which is normal. The brow looks sparser than on the day of surgery for a while.",
        },
        {
          name: "Month 6–9",
          text:
            "The new brow hair is established. From then on it grows long and is trimmed with small scissors " +
            "every few weeks.",
        },
      ],
    },
    risks: {
      heading: "What can go wrong",
      intro: "On the face, small technical errors are visible. These are the ones to discuss.",
      items: [
        "An unnatural direction or a too-dense patch that looks like a plug",
        "Asymmetry between the two brows — perfect symmetry is not achievable",
        "Graft loss in scarred skin, where blood supply is weaker",
        "Folliculitis or small cysts in the first weeks",
        "Hair that grows faster and longer than the original brow, needing regular trimming",
      ],
      note:
        "Ask to see healed results at six months or more, not the day after surgery. Direction and density " +
        "only become visible once the hair has settled.",
    },
    faq: {
      heading: "Questions patients ask",
      items: [
        {
          q: "Will it look natural?",
          a:
            "When single hairs are used and placed at the correct angle, yes — at conversation distance it " +
            "reads as a normal brow. The risk is over-density, which is why the first pass is conservative.",
        },
        {
          q: "Can I still shape them?",
          a:
            "Yes, but carefully. Plucking and waxing are avoided; trimming with scissors is how transplanted " +
            "brows are maintained.",
        },
        {
          q: "How soon can I wear makeup?",
          a: "After about 7–10 days, once the scabs have gone and the skin is closed.",
        },
        {
          q: "Do I need a second session?",
          a:
            "Often yes for density, planned after 9–12 months. The first session is designed to establish " +
            "the shape, the second to fill it.",
        },
      ],
    },
    ctaBand: {
      heading: "Send your photographs for a first opinion",
      text: "A close photo of each brow, front and at an angle, is enough to judge what can be rebuilt.",
      button: "Send your photos",
    },
    disclaimer:
      "General information, not medical advice. Brow suitability is judged in person; results vary between patients.",
  },

  ar: {
    title: "زراعة الحواجب في إسطنبول",
    eyebrow: "زراعة الشعر",
    lead:
      "تُؤخذ شعيرات مفردة من فروة الرأس وتُزرع في الحاجب بالزاوية التي تنمو بها كل شعرة، " +
      "لإعادة بناء حاجب تركّه النتف أو الندبة أو الوراثة خفيفاً.",
    cta: "احجز تقييماً مجانياً",
    heroAlt: "استشارة زراعة الحواجب في عيادة بلاتينيا",
    stats: [
      { value: "٣–٤ ساعات", label: "مدة الجلسة" },
      { value: "٢٠٠–٤٠٠", label: "بصيلة لكل حاجب" },
      { value: "٦–٩ أشهر", label: "الشكل النهائي" },
    ],
    candidate: {
      heading: "لمن تُناسب",
      intro:
        "الحاجب أظهر عملية على الوجه، لذا المهمة الأولى أن نقرّر هل الشكل ما زال موجوداً ليُبنى من جديد.",
      items: [
        "خفّة بعد سنوات من النتف المفرط توقّفت فيها البصيلات عن التعافي",
        "ندبات من حروق أو جروح أو إزالة مكياج دائم",
        "حواجب خفيفة أو غير متناظرة طبيعياً، أو تساقط بعد العلاج الكيميائي لم يعد",
        "جلد سليم بلا أكزيما أو صدفية أو التهاب نشط في منطقة الحاجب",
      ],
      note:
        "إذا كانت الخفّة بسبب الغدة الدرقية أو نقص تغذوي فذلك يُعالَج أولاً. الشعر المأخوذ من الفروة ينمو مثل شعر " +
        "الرأس ويحتاج قصّاً — وهذه صيانة دائمة يجب فهمها قبل الحجز.",
    },
    techniques: {
      heading: "كيف تُنفَّذ",
      intro: "دقّة لا كثرة: بضع مئات من الشعيرات المفردة، كل واحدة بزاويتها.",
      items: [
        {
          name: "بصيلات مفردة",
          text:
            "تُستخدم وحدات ذات شعرة أو شعرتين فقط. البصيلات المتعدّدة تبدو متكتّلة في الحاجب، " +
            "لذلك تُختار المنطقة المانحة لشعر رفيع مفرد — غالباً من خلف الأذن.",
        },
        {
          name: "الزاوية والاتجاه",
          text:
            "شعر الحاجب ينمو صعوداً للخارج عند الرأس وينبسط نحو الطرف. تُوضع كل بصيلة على حدة لتتبع هذا النمط، " +
            "وإلا بدت النتيجة غير طبيعية.",
        },
        {
          name: "الكثافة على مرحلتين",
          text:
            "مرحلة أولى متحفّظة تحمي تروية جلد الحاجب الرقيق؛ وجلسة ثانية بعد ٩–١٢ شهراً تضيف الكثافة " +
            "حيث تحتاج بدل التكثيف الزائد من البداية.",
        },
      ],
    },
    journey: {
      heading: "من التصميم إلى الشكل النهائي",
      steps: [
        {
          name: "التصميم على الوجه",
          text:
            "يُرسم الحاجب وأنت جالس، ويُقاس مقابل الجانب الآخر ونسب الوجه، ويُتفق عليه قبل أخذ أي بصيلة.",
        },
        {
          name: "العملية",
          text:
            "تخدير موضعي. اقتطاف من المنطقة المانحة ثم زرع بإبر دقيقة. ثلاث إلى أربع ساعات للحاجبين.",
        },
        {
          name: "أول عشرة أيام",
          text: "قشور صغيرة؛ بلا مكياج على المنطقة، بلا فرك، وبلا نوم على الوجه. التورّم يهدأ في أسبوع.",
        },
        {
          name: "الأسبوع ٣–٨",
          text: "معظم البصيلات تتساقط وهذا طبيعي. يبدو الحاجب أخفّ من يوم العملية لفترة.",
        },
        {
          name: "الشهر ٦–٩",
          text:
            "يستقرّ شعر الحاجب الجديد. من ثمّ ينمو طويلاً ويُقصّ بمقص صغير كل بضعة أسابيع.",
        },
      ],
    },
    risks: {
      heading: "ما قد يسوء",
      intro: "في الوجه، الأخطاء التقنية الصغيرة تُرى. هذه أهمّها للنقاش.",
      items: [
        "اتجاه غير طبيعي أو رقعة كثيفة تبدو كحشوة",
        "عدم تناظر بين الحاجبين — التناظر التام غير قابل للتحقيق",
        "فقدان بصيلات في الجلد المندب حيث التروية أضعف",
        "التهاب جريبات أو أكياس صغيرة في الأسابيع الأولى",
        "شعر ينمو أسرع وأطول من الحاجب الأصلي ويحتاج قصّاً منتظماً",
      ],
      note:
        "اطلب رؤية نتائج شافية بعد ستة أشهر أو أكثر، لا في اليوم التالي. الاتجاه والكثافة لا يظهران إلا بعد استقرار الشعر.",
    },
    faq: {
      heading: "أسئلة يطرحها المرضى",
      items: [
        {
          q: "هل سيبدو طبيعياً؟",
          a:
            "عند استخدام شعيرات مفردة وبالزاوية الصحيحة نعم — على مسافة الحديث يبدو حاجباً طبيعياً. " +
            "الخطر هو الكثافة الزائدة، ولهذا تكون المرحلة الأولى متحفّظة.",
        },
        {
          q: "هل أستطيع تشكيله كالمعتاد؟",
          a:
            "نعم بحذر. يُجتنب النتف والشمع؛ والصيانة تكون بالقصّ بالمقص.",
        },
        {
          q: "متى أضع المكياج؟",
          a: "بعد ٧–١٠ أيام، حين تزول القشور ويُغلق الجلد.",
        },
        {
          q: "هل أحتاج جلسة ثانية؟",
          a:
            "غالباً نعم للكثافة، وتُخطَّط بعد ٩–١٢ شهراً. الجلسة الأولى تُثبّت الشكل والثانية تملؤه.",
        },
      ],
    },
    ctaBand: {
      heading: "أرسل صورك لرأي أوّلي",
      text: "صورة قريبة لكل حاجب، من الأمام ومن زاوية، تكفي للحكم على ما يمكن إعادة بنائه.",
      button: "أرسل صورك",
    },
    disclaimer:
      "معلومات عامة وليست نصيحة طبية. تُقدَّر الملاءمة بالفحص المباشر؛ والنتائج تختلف من مريض لآخر.",
  },
};
